import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a22227b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "notFoundEstablishment"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Nenhum estabelecimento encontrado :(", -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EstablishmentCardSkeleton = _resolveComponent("EstablishmentCardSkeleton")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_coupon_card = _resolveComponent("coupon-card")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!
  const _component_network_error = _resolveComponent("network-error")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loadingRef)
      ? (_openBlock(), _createBlock(_component_ion_grid, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (i) => {
                  return _createVNode(_component_ion_col, {
                    key: i,
                    "size-xs": "12",
                    "size-sm": "12",
                    "size-md": "6",
                    "size-lg": "6",
                    "size-xl": "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EstablishmentCardSkeleton)
                    ]),
                    _: 2
                  }, 1024)
                }), 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_ion_grid, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_row, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createBlock(_component_ion_col, {
                key: item.id,
                class: "no-padding",
                "size-xs": "12",
                "size-sm": "12",
                "size-md": "6",
                "size-lg": "6",
                "size-xl": "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_coupon_card, { item: item }, null, 8, ["item"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        (_ctx.items.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
          : _createCommentVNode("", true),
        _createVNode(_component_ion_infinite_scroll, {
          onIonInfinite: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getNextItems($event)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_infinite_scroll_content, { "loading-ref-spinner": "dots" })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.occurredError)
      ? (_openBlock(), _createBlock(_component_network_error, {
          key: 1,
          refresh: _ctx.getItems
        }, null, 8, ["refresh"]))
      : _createCommentVNode("", true)
  ], 64))
}